<template>
  <div>
      <main-header></main-header>
      <div class="loginmain">
        <div class="w1200">
          <div class="cont">
            <h1>{{language[languagetype].logintitlea}}</h1>
            <span>{{language[languagetype].logintitleb}}</span>
          </div>
          <div class="loginform">
            <div class="formlogo">
              <img :src="logo" alt="">
            </div>
            <div class="title">{{language[languagetype].logintitle}}</div>
            <div class="inputbox">
              <input type="text" :placeholder="language[languagetype].userplea" v-model="username">
            </div>
            <div class="inputbox">
              <input type="password" :placeholder="language[languagetype].passwordplea" v-model="password">
            </div>
            <div class="inputbox2" v-if="codenum >= 2">
              <input type="text" :placeholder="language[languagetype].codeplea" v-model="code">
              <div class="codetext">{{codetext}}</div>
            </div>
            <div class="submitbtn" @click="login">{{language[languagetype].login}}</div>
            <div :class="lang == 1 ? 'logindesc' : 'logindescen'">
              <div>{{language[languagetype].nouser}}<font @click='registerpage'>{{language[languagetype].resiger}}</font></div>
            </div>
          </div>
        </div>
      </div>
      <toast ref="toasttext"></toast>
  </div>
</template>

<script>
import toast from '../components/taast/toast'
import Fetch from '../js/ajaxa'
import MainHeader from './header'
import httppost from '../js/ajax'
let languagetext = require('../js/loginlang.json')

export default {
  name: 'index',
  data () {
    return {
      username: null,
      password: null,
      codenum: 0,
      code: '',
      codetext: '',
      lang: 1,
      language: {},
      languagetype: 'cn',
      logo: ''
    }
  },
  methods: {
    registerpage: function () {
      this.$router.push({name: 'register'})
    },
    login: function () {
      const that = this
      if (that.codenum >= 2) {
        if (that.code == null || that.code === '') {
          that.$refs.toasttext.show(that.language[that.languagetype].codenull)
          that.coderefresh()
          return false
        }
        if (that.code !== that.codetext) {
          that.$refs.toasttext.show(that.language[that.languagetype].codeerror)
          that.coderefresh()
          return false
        }
      }
      if (that.username == null || that.username === '') {
        that.$refs.toasttext.show(that.language[that.languagetype].usernamenull)
        return false
      }
      if (that.password == null || that.password === '') {
        that.$refs.toasttext.show(that.language[that.languagetype].passwordnull)
        return false
      }
      httppost.post('Api/http', {
        name: 'portal.login.validate',
        account: that.username,
        password: that.password
      }).then((res) => {
        if (res.code !== '0') {
          that.$refs.toasttext.show(res.msg)
          that.codenum++
          that.coderefresh()
        } else {
          localStorage.setItem('username', JSON.stringify(res.data))
          that.$refs.toasttext.show(that.language[that.languagetype].loginsuccful)
          setTimeout(function () {
            that.$router.push({name: 'index'})
          }, 1000)
        }
      }).catch(err => {
        console.log(err.msg)
        that.$refs.toasttext.show(that.language[that.languagetype].loginfial)
        that.codenum++
        that.coderefresh()
      })
    },
    coderefresh: function () {
      const that = this
      that.codetext = ''
      var codeChars = [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z' ]
      for (var i = 0; i < 4; i++) {
        that.codetext = codeChars[Math.floor(Math.random() * 36)] + this.codetext
      }
    }
  },
  created () {
    const that = this
    that.language = languagetext
    that.username = JSON.parse(localStorage.getItem('username'))
    that.lang = sessionStorage.getItem('lang') || 1
    // eslint-disable-next-line
    if (that.lang != 1) {
      that.languagetype = 'en'
    }
    Fetch.post('Api/config', {
    }).then((res) => {
      that.logo = res.image
    }).catch(err => {
      console.log(err)
    })
  },
  components: {
    MainHeader,
    toast
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .loginmain{height: 640px;background: url("../assets/loginbg.jpg") center 0 no-repeat;overflow: hidden;}
  .loginform{width: 450px;height: 540px;float: right;margin-top: 50px;background-color: #fff;box-sizing: border-box;padding:  0 75px;overflow: hidden;}
  .loginmain .cont{width: 600px;height: 73px;margin-top: 288px;float: left;}
  .loginmain .cont h1{display: block;width: 100%;height: 43px;line-height: 43px;text-align: center;font-size: 30px;font-weight: bold;color: #fff;}
  .loginmain .cont span{display: block;width: 100%;height: 30px;line-height: 30px;font-size: 20px;text-align: center;color: #fff;}
  .formlogo{width: 300px;height: 52px;margin-top: 43px;overflow: hidden;display: flex;align-items: center;}
  .formlogo img{width: auto;height: auto;max-width: 100%;max-height: 100%;}
  .loginform .title{width: 100%;height: 95px;line-height: 95px;font-size: 30px;}
  .inputbox{width: 100%;height: 40px;border-bottom: 1px solid #c5c5c5;overflow: hidden;display: flex;margin-bottom: 28px;}
  .inputbox input{border: none;outline: none;flex: 1;}
  .inputbox2{width: 100%;height: 40px;border-bottom: 1px solid #c5c5c5;overflow: hidden;display: flex;margin-bottom: 28px;}
  .inputbox2 input{border: none;outline: none;width:70%;flex: 1;}
  .inputbox2 .codetext{width: 30%;height: 40px;background-color: #D8B7E3;display: flex;align-items: center;justify-content: center;font-size: 16px;}
  .submitbtn{width: 100%;height: 50px;background-color:#2a3c66;color: #fff;font-size: 20px;text-align: center;line-height: 50px;cursor: pointer;}
  .logindesc{width: 100%;height: 68px;line-height: 68px;display: flex;color: #999999;justify-content: space-between;}
  .logindesc font{color: #F90000;cursor: pointer;}
  .logindescen{width: 100%;height: auto;overflow: hidden;margin-top: 5px;}
  .logindescen div{display: block;line-height: 32px;}
  .logindescen font{color: #F90000;cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/page/login.vue